var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dp-arch-premium b-paragraph-l b-vspace-m" },
    [
      _c("p", { staticClass: "b-vspace-s" }, [
        _vm._v("Subscribe to Premium to get access to the full archives.")
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        {
          directives: [
            {
              name: "track",
              rawName: "v-track:click",
              value: {
                axId: "clicked_b2_daily_problems_archives",
                axType: "button"
              },
              expression:
                "{\n      axId: 'clicked_b2_daily_problems_archives',\n      axType: 'button',\n    }",
              arg: "click"
            }
          ],
          staticClass: "btn btn-outline",
          attrs: { to: { name: "chargebee_paywall" } }
        },
        [_vm._v("\n    Subscribe now\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }